import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetAssociatedModelsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: (data: GetAssociatedModelsResponse) => ReactElement
}

const GetAiAssetsRequest = ({
  id,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/assets/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiAssetsRequest
